import { ApolloLink, Observable, Operation } from '@apollo/client';
import { SubscriptionClient } from 'subscriptions-transport-ws';

export class LegacyWebSocketLink extends ApolloLink {
    private readonly subscriptionClient: SubscriptionClient;

    constructor(subscriptionClient: SubscriptionClient) {
        super();
        this.subscriptionClient = subscriptionClient;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public request(operation: Operation, forward?: ApolloLink.ForwardFunction): Observable<any> {
        return new Observable(observer => {
            const subscription = this.subscriptionClient.request(operation).subscribe({
                next: result => {
                    observer.next(result);
                },
                error: err => {
                    observer.error(err);
                },
                complete: () => {
                    observer.complete();
                }
            });

            return () => {
                subscription.unsubscribe();
            };
        });
    }
}
